module.exports = __webpack_public_path__ + "static/media/savio30.d6893928.jpg";